namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'dashboard-overview-component-template',
        bindings: {}
    })
    class DashboardOverviewComponent {
        public contests = null;

        public constructor(public RepositoryService: RepositoryService) {
            this.getContests();
        }

        getContests() {
            this.RepositoryService.getContestsOverview().then((contests) => {
                this.contests = contests;
            });
        }
    }
}